// This is the width at which we determine the interval is too short to have the text inside
export const MOVE_INTERVAL_TEXT_OUTSIDE = 180;

// this is the width of a point, if an interval is narrower than a point it should just be a point
export const COLLAPSE_INTERVAL_TO_POINT = 48;
// points are smaller when condensed
export const COLLAPSE_INTERVAL_TO_POINT_CONDENSED = 8;

// this is the height of a pellet row, important for when we want to calculate rowOffsets
export const PELLET_ROW_HEIGHT = 48;
// pellets are smaller when condensed
export const PELLET_ROW_HEIGHT_CONDENSED = 12;
